import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <main className="bg-auth-bg relative min-h-dvh bg-cover">
      <Outlet />
    </main>
  );
};

export default AuthLayout;
